export function getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
}

export function generateFileName(file, folder) {
    const timestamp = new Date().getTime();
    return `${folder}/${timestamp}-${file.name.toLowerCase().replace(/[^a-z0-9.]/g, '-')}`;
} 